import { startCase } from 'lodash';

import { selectEvaluationData } from 'store/slice/notesHtmlData.slice';

import { useAppSelector } from 'hooks';
import './scrollbar.css';
import RenderEvalContent from './Questions';

export default function Evaluation() {
  const evaluationData = useAppSelector(selectEvaluationData);

  return (
    <div className='flex flex-col flex-1 min-h-0 m-2 bg-[#1B1F3B] rounded-lg overflow-hidden'>
      {/* Header section */}
      <div className='shrink-0 p-6 bg-[#243154] shadow-md rounded-t-md'>
        <h2 className='text-2xl font-bold text-white'>
          {startCase(evaluationData?.evaluationType) || 'Evaluation Questions'}
        </h2>
      </div>

      <div className='relative flex-1 min-h-0'>
      <div className='absolute inset-0 px-6 py-4 space-y-6 overflow-y-auto custom-scrollbar'>
        {evaluationData?.questions?.length > 0 ? (
          evaluationData?.questions?.map((question, index) => (
            <div
              key={question?._id}
              className='p-6 transition-all duration-300 ease-in-out bg-[#2A3C5E] rounded-lg shadow-md hover:shadow-lg hover:bg-[#3B4B72]'
            >
              <h3 className='mb-4 text-lg font-semibold text-white'>Question {index + 1}</h3>
              <div className='relative text-white'>
                <RenderEvalContent value={question?.question_description || []} />
              </div>
            </div>
          ))
        ) : (
          <div className='p-6 bg-[#2A3C5E] rounded-lg shadow-md'>
            <p className='text-white'>No questions available.</p>
          </div>
        )}
      </div>
      </div>
    </div>
  );
}
